// extracted by mini-css-extract-plugin
module.exports = {"title":"BlockTitle_title__EiryI","lg":"BlockTitle_lg__3rNuS","md":"BlockTitle_md__3WSNV","sm":"BlockTitle_sm__3yAKe"};